// extracted by mini-css-extract-plugin
export var closeButton = "_70-0";